import React from 'react';
import graphql from 'graphql';
import ScrollAnimation from 'react-animate-on-scroll';
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel";
import mapStyles from '../json/map.json';
import { googleMapsApiKey } from '../../site.json';
import { isMobile, isIOS, isAndroid } from 'react-device-detect';

const Map = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div />,
    containerElement: <div style={{ height: `100%`, width: '100%' }} />,
    mapElement: <div className="b-contact-map-container" />,
  }),
  withScriptjs,
  withGoogleMap
)(({ defaultCenter, coordinates, showMarker }) =>
  <GoogleMap
    defaultZoom={17}
    defaultCenter={defaultCenter ? defaultCenter : coordinates}
    defaultOptions={{ background: "#000000", styles: mapStyles, disableDefaultUI: true }}
  >
    <MarkerWithLabel
      defaultIcon="CIRCLE"
      position={coordinates}
      labelAnchor={new google.maps.Point(32, 32)}
      onClick={() => {
        window.open(`https://www.google.com/maps?ll=${coordinates.lat},${coordinates.lng}&z=17&t=m&hl=et&gl=US&mapclient=apiv3`, '_blank');
      }}
    >
      <div className={`b-marker animated ${showMarker ? 'zoomIn' : 'zoomOut'}`}></div>
    </MarkerWithLabel>
  </GoogleMap>
);

export class ContactPageTemplate extends React.Component {

  state = {
    appeared: false,
    mounted: false,
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  render() {
    const {
      title,
      addressLine,
      addressLine2,
      lat,
      lng,
      phone,
      email,
      links,
    } = this.props;

    const coordinates = { lat: parseFloat(lat), lng: parseFloat(lng) };

    return (
      <ScrollAnimation
        offset={200}
        duration={0.3}
        animateIn="fadeIn"
        animateOut="fadeOut"
        afterAnimatedIn={(visible) => this.setState({ appeared: visible.onScreen })}
        afterAnimatedOut={() => this.setState({ appeared: false })}
      >
        <section className="section m-special-scrollanimation" style={{ zIndex: 0 }}>
          <section className="section m-text-red b-fixed-section">
            <div className="container is-fluid" style={{ zIndex: 1 }}>
              <div className="columns">
                <div className="column is-12">
                  <h1 className={`home-title is-size-3 is-size-4-touch`}>
                    {title}
                  </h1>
                </div>
              </div>
              <div className="columns is-8 is-margin-top-5-desktop">
                <div className="column is-4">
                  <div className="home-title content is-size-3 is-size-5-touch is-size-6-mobile m-uc m-b">
                    <p>{addressLine}</p>
                    <p>{addressLine2}</p>
                  </div>
                </div>
                <div className="column is-7 is-offset-1">
                  <div className="home-title content is-size-3 is-size-5-touch is-size-6-mobile m-uc m-b">
                    <p>
                      Phone: <a href={`tel:${phone}`}>{phone}</a><br />
                      E-mail: <a href={`mailto:${email}`}>{email}</a>
                    </p>
                    <div>
                      {links.map(({ text, url, iosUrl, androidUrl }) => (
                        <div key={text}><a target="_blank" href={url ? (this.state.mounted && isMobile ? (isIOS && iosUrl ? iosUrl : (isAndroid && androidUrl ? androidUrl : url)) : url) : '#'}>{text}</a></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="b-contact-map">
              <Map coordinates={coordinates} showMarker={this.state.appeared}/>
            </div>
          </section>
        </section>
      </ScrollAnimation>
    )
  }
}

export default ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <ContactPageTemplate {...frontmatter} />
  );
};

export const fragment = graphql`
  fragment contactPage on MarkdownRemark {
    frontmatter {
      title
      addressLine
      addressLine2
      lat
      lng
      phone
      email
      links {
        text
        url
        iosUrl
        androidUrl
      }
    }
  }
`

export const contactPageQuery = graphql`
  query ContactPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      ...contactPage
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/contact-page.js